<template>
  <div class="agb-data">
    <slot name="txtBefore">Allgemeine Vertragsbedingungen, Vertragszusammenfassung und Widerrufsrecht</slot>
    <div class="agb-consent">
      <slot name="txAgbConsent"></slot>
    </div>
    <div class="agb-information-article">
      <slot name="lblInformationArticle"></slot>
    </div>
  </div>
</template>
<script>
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'AGB',
  props: {
    consent: {
      type: String
    }
  },
  created () {
    this.selectedConsentAGB = true
    this.selectedInformationArticle = true
  },
  mixins: [
    syncProperty('consentAGBProp', 'selectedConsentAGB'),
    syncProperty('consentInformationArticleProp', 'selectedInformationArticle')
  ]
}
</script>
